import { PermissionForStudents } from '../../access-role-permissions/users-permissions-constants/student-roles-permissions.enum';

export const MODULE_LANDING_MAP: { [key: string]: string } = {
	dashboard: '/student-dashboard',
	recruiter: '/recruiter-dashboard/dashboard',
	admin_dashboard: '/admin-student-platform/dashboard',
	quiz: '/student-dashboard/student-quiz',
	course: '/student-dashboard/pro-course',
	user_management: '/admin-student-platform/users',
	mentor: '/student-dashboard/mentors',
	classroom: '/student-dashboard/classrooms',
	interview: '/student-dashboard/ai-interview-dashboard',
	notification: '/student-dashboard/notification',
	higher_studies: '/student-dashboard/higher-studies',
	placement: '/student-dashboard/placement-prep',
	user: '/student-dashboard/profile',
	payment: '/student-dashboard/payment-history',
	usage: '/student-dashboard/usage',
	super_admin_dashboard: '/super-admin-dashboard',
	mentor_panel: '/mentor-panel/dashboard',
	roadmap: 'student-dashboard/my-roadmap',
	resume: 'student-dashboard/resume',
	proctoring: '/proctoring-dashboard/dashboard'
};

export interface SidenavItem {
	module: string;
	label: string;
	icon: string;
	route: string;
	subItems?: SidenavItem[];
	permission?: string | string[];
	excludePermission?: string | string[];
}

export const SIDENAV_CONFIG: SidenavItem[] = [

	{
		module: 'dashboard',
		label: 'Dashboard',
		icon: 'grid_view',
		route: '/admin-student-platform/dashboard',
		permission: PermissionForStudents.DASHBOARD_ADMIN
	},
	{
		module: 'mentor',
		label: 'Dashboard',
		icon: 'dashboard',
		route: '/mentor-panel/dashboard',
		permission: PermissionForStudents.DASHBOARD_MENTOR
	},
	{
		module: 'proctoring',
		label: 'Proctoring Dashboard',
		icon: 'verified_user',
		route: '/proctoring-dashboard/dashboard',
		permission: PermissionForStudents.PROCTORING_READ
	},
	{
		module: 'job',
		label: 'Dashboard',
		icon: 'dashboard',
		route: '/recruiter-dashboard/dashboard',
		permission: [
			PermissionForStudents.JOB_MANAGE,
		],
		excludePermission: [PermissionForStudents.DASHBOARD_ADMIN]
	},
	{
		module: 'dashboard',
		label: 'Dashboard',
		icon: 'dashboard',
		route: '/student-dashboard/home',
		permission: PermissionForStudents.DASHBOARD_STUDENT
	},
	{
		module: 'college_portal',
		label: 'Dashboard',
		icon: 'dashboard',
		route: '/college-dashboard/overview',
		permission: PermissionForStudents.COLLEGE_PORTAL_READ
	},

	// --- STUDENT MODULES ---
	{
		module: 'resume',
		label: 'Resume Builder',
		icon: 'description',
		route: '/student-dashboard/resume',
		permission: PermissionForStudents.RESUME_READ
	},
	{
		module: 'placement',
		label: 'Mock Test',
		icon: 'assignment_turned_in',
		route: '/student-dashboard/placement-prep',
		permission: PermissionForStudents.PLACEMENT_VIEW
	},
	{
		module: 'interview',
		label: 'Mock Interview',
		icon: 'record_voice_over',
		route: '/student-dashboard/ai-interview-dashboard',
		permission: PermissionForStudents.DASHBOARD_STUDENT,
		excludePermission: [PermissionForStudents.DASHBOARD_ADMIN]
	},
	{
		module: 'jobs',
		label: 'Jobs',
		icon: 'business_center',
		route: '/student-dashboard/jobs',
		permission: PermissionForStudents.JOB_APPLY,
		excludePermission: [PermissionForStudents.DASHBOARD_ADMIN]
	},
	{
		module: "roadmap",
		label: 'Roadmap',
		icon: 'insights',
		route: '/student-dashboard/my-roadmap',
		permission: PermissionForStudents.ROADMAP_VIEW
	},
	//{
	//	module: 'mentor',
	//	label: 'Mentor Sessions',
	//	icon: 'video_camera_front',
	//	route: '/student-dashboard/mentors',
	//	permission: PermissionForStudents.MENTOR_VIEW
	//},
	//{
	//	module: 'course',
	//	label: 'Pro Courses',
	//	icon: 'workspace_premium',
	//	route: '/student-dashboard/pro-course',
	//	permission: [PermissionForStudents.COURSE_VIEW],
	//	excludePermission: [PermissionForStudents.DASHBOARD_ADMIN, PermissionForStudents.COURSE_MANAGE_LIST, PermissionForStudents.QUIZ_MANAGE_LIST]

	//},
	// { not using for now
	//     module: 'course',
	//     label: 'My Learning',
	//     icon: 'menu_book',
	//     route: '/student-dashboard/my-learning',
	//     permission: [PermissionForStudents.COURSE_VIEW],
	//     excludePermission: [PermissionForStudents.DASHBOARD_ADMIN,PermissionForStudents.COURSE_MANAGE_LIST,PermissionForStudents.QUIZ_MANAGE_LIST]

	// },
	//{
	//	module: 'higher_studies',
	//	label: 'Higher Studies',
	//	icon: 'psychology',
	//	route: '/student-dashboard/higher-studies',
	//	permission: PermissionForStudents.HIGHER_STUDIES_ACCESS
	//},

	// --- ADMIN MODULES ---
	{
		module: 'course',
		label: 'Content',
		icon: 'folder_open',
		route: '',
		permission: [
			PermissionForStudents.COURSE_MANAGE_LIST,
			PermissionForStudents.QUIZ_MANAGE_LIST,
			PermissionForStudents.PRACTICE_INTERVIEW_MANAGE_LIST
		],
		subItems: [
			{
				module: 'course',
				label: 'Courses',
				icon: 'menu_book',
				route: '/admin-student-platform/admin-courses',
				permission: PermissionForStudents.COURSE_MANAGE_LIST
			},
			{
				module: 'quiz',
				label: 'Quizzes',
				icon: 'quiz',
				route: '/admin-student-platform/admin-quiz',
				permission: PermissionForStudents.QUIZ_MANAGE_LIST
			},
			{
				module: 'practice_interview',
				label: 'Interviews',
				icon: 'co_present',
				route: '/admin-student-platform/admin-interview',
				permission: PermissionForStudents.PRACTICE_INTERVIEW_MANAGE_LIST
			}
		]
	},
	{
		module: 'user_management',
		label: 'User Management',
		icon: 'manage_accounts',
		route: '/admin-student-platform/users',
		permission: [
			PermissionForStudents.USER_MANAGEMENT_VIEW,
			PermissionForStudents.USER_MANAGEMENT_VIEW_ENROLLMENTS,
			PermissionForStudents.USER_MANAGEMENT_VIEW_QUIZZES
		]
	},
	{
		module: 'payment',
		label: 'Payments & Invoices',
		icon: 'credit_card',
		route: '/admin-student-platform/billing',
		permission: PermissionForStudents.PAYMENTS_MANAGE_LIST
	},
	{
		module: 'company-management',
		label: 'Company Management',
		icon: 'corporate_fare',
		route: '',
		permission: PermissionForStudents.COMPANY_MANAGE,
		subItems: [
			{
				module: 'all companies',
				label: 'All Companies',
				icon: 'business',
				route: '/admin-student-platform/company-management/all-companies',
				permission: PermissionForStudents.COMPANY_MANAGE
			},
			{
				module: 'company approval',
				label: 'Pending Company Approval',
				icon: 'verified',
				route: '/admin-student-platform/company-management/company-approval',
				permission: PermissionForStudents.COMPANY_MANAGE
			},
			{
				module: 'job approval',
				label: 'All Jobs',
				icon: 'work',
				route: '/admin-student-platform/company-management/all-jobs',
				permission: PermissionForStudents.COMPANY_MANAGE
			},
			{
				module: 'job approval',
				label: 'Pending Job Approval',
				icon: 'assignment_turned_in',
				route: '/admin-student-platform/company-management/job-approval',
				permission: PermissionForStudents.COMPANY_MANAGE

			},
			{
				module: 'candidate',
				label: 'Candidates',
				icon: 'supervisor_account',
				route: '/admin-student-platform/company-management/candidates',
				permission: PermissionForStudents.COMPANY_MANAGE

			}

		]
	},
	{
		module: 'college-management',
		label: 'College Management',
		icon: 'school',
		route: '/admin-student-platform/college-management/all-colleges',
		permission: PermissionForStudents.COLLEGE_PORTAL_MANAGE
	},

	// --- MENTOR MODULES ---
	{
		module: 'mentor',
		label: 'Session Requests',
		icon: 'pending_actions',
		route: '/mentor-panel/session-requests',
		permission: PermissionForStudents.DASHBOARD_MENTOR
	},
	{
		module: 'mentor',
		label: 'Scheduled Sessions',
		icon: 'event_available',
		route: '/mentor-panel/upcoming-sessions',
		permission: PermissionForStudents.DASHBOARD_MENTOR
	},
	{
		module: 'mentor',
		label: 'Session History',
		icon: 'history',
		route: '/mentor-panel/session-history',
		permission: PermissionForStudents.DASHBOARD_MENTOR
	}
];
